// Import necessary modules and components.
import { FC, useEffect, useRef, useState } from 'react'
// !DEPRICATED feb-05-2026
// import SearchOutlined from "@ant-design/icons/SearchOutlined"

import { CheckBoxV2 } from '../checkbox-v2'
import { InputFieldV2 } from '../input-field-v2'
import { DropDownV2Type } from './drop-down-v2.types'

import {
  filledArrowDownward,
  filledArrowDownwardWhite,
  filledArrowUpward,
} from './drop-down-v2.assets'

export const DropDownV2: FC<DropDownV2Type> = ({
  menuItems,
  label,
  placeholder = 'Search',
  showSearch = true,
  inputValue,
  handleInputChange,
  handleCheckBoxChange,
}) => {
  // State variables to manage component behavior.

  //state to toggle dropdown
  const [showDropDown, setDropDown] = useState(false)

  //state to keep count of selected items
  const [selectedItems, setSelectedItems] = useState(0)

  //state to keep track of checked items
  const [checkedItems, setCheckedItems] = useState<string[]>([])

  // Define component refs for the header and dropdown elements.
  const headerRef = useRef<HTMLDivElement | null>(null)
  const dropDownRef = useRef<HTMLDivElement | null>(null)

  // Use the useEffect hook to handle clicks outside the component.
  useEffect(() => {
    // Define a function to handle clicks outside the component.
    const handleClickOutside = (event: MouseEvent) => {
      if (
        // Check if the headerRef exists and the click target is not within it.
        !headerRef?.current?.contains(event.target as Node) &&
        // Check if the dropDownRef exists and the click target is not within it.
        !dropDownRef?.current?.contains(event.target as Node)
      ) {
        // Close the dropdown by setting showDropDown to false.
        setDropDown(false)
      }
    }

    // Attach the event listener when the component mounts.
    document.addEventListener('click', handleClickOutside)

    // Remove the event listener when the component unmounts to prevent memory leaks.
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  // Function to check if an item is checked based on its value.
  const trackCheckedValues = (value: string) => {
    return checkedItems.includes(value)
  }

  // Function to handle changes when a checkbox is checked or unchecked.
  const handleChange = (
    // The new checked state of the checkbox.
    checked: boolean | string,
    // The unique key associated with the checkbox item.
    key: string | number,
    // The label or text of the checkbox item.
    label: string
  ) => {
    // Create a copy of the current checked items array.
    const checkedData = checkedItems
    // Combine the key and label to form a unique value for the checkbox item.
    const value = key.toString() + label

    // If the checkbox is checked, add the value to the checked items.
    if (checked) {
      checkedData.push(value)
      // Update the checked items.
      setCheckedItems(checkedData)
      // Increment the count of selected items.
      setSelectedItems((prev) => prev + 1)
    } else {
      // If the checkbox is unchecked, remove the value from the checked items.
      const removedData = checkedData.filter(
        (checkedValue) => checkedValue !== value
      )
      // Update the checked items with the removed value.
      setCheckedItems(removedData)
      // Decrement the count of selected items.
      setSelectedItems((prev) => prev - 1)
    }

    // If a callback function for checkbox change is provided, invoke it.
    if (handleCheckBoxChange) {
      handleCheckBoxChange(checked, key)
    }
  }

  return (
    <div className="relative flex flex-col">
      {/* Dropdown header */}
      <div
        className={` ${
          showDropDown || selectedItems > 0
            ? 'bg-blue-5 border border-[1px] border-blue-5 cursor-pointer '
            : 'bg-white hover:bg-light-gray border border-[1px] border-grey-20'
        } flex h-fit w-fit items-center justify-between rounded-lg p-[0.43rem] `}
        onClick={() => {
          setDropDown(!showDropDown)
        }}
        ref={headerRef}
      >
        <p
          className={` ${
            showDropDown || selectedItems > 0 ? 'text-blue-50' : 'text-dark-gray'
          } m-0 mr-2 w-fit cursor-pointer montserrat text-base md:text-sm lg:text-sm`}
        >
          {label}
          {selectedItems > 0 && ` :+${selectedItems}`}
        </p>
        {showDropDown
          ? filledArrowUpward()
          : selectedItems > 0
          ? filledArrowDownwardWhite()
          : filledArrowDownward()}
      </div>

      {/* Dropdown content */}
      {showDropDown && (
        <div
          className={`${
            showSearch ? 'p-[14px]' : 'p-0'
          } absolute left-0 top-11 z-20 w-[256px] rounded-lg bg-white border border-[1px] border-grey-20 shadow-xl md:w-[218px] lg:w-[218px]`}
          ref={dropDownRef}
        >
          {showSearch && (
            <div className="mb-3 px-[1px]">
              {/* Input field for searching */}
              <InputFieldV2
                name={label}
                value={inputValue ? inputValue : ''}
                placeholder={placeholder ? placeholder : 'Search'}
                icon={<span>SearchOutlined</span>}
                handleChange={(e) => {
                  if (handleInputChange) {
                    handleInputChange(e)
                  }
                }}
              />
            </div>
          )}

          <div className="dropdown-scrollbar flex h-fit max-h-[156px] flex-col overflow-y-auto">
            {/* List of checkboxes */}
            {menuItems.map((menu, index) => {
              let checkBoxStyles = ''

              // if (index === menuItems.length - 1) {
              //   checkBoxStyles += 'mb-[6px]'
              // }

              const isChecked = trackCheckedValues(menu.key.toString() + menu.label)

              if (menu.className) {
                checkBoxStyles += menu.className
              }

              return (
                <div className='hover:bg-blue-5 p-3 h-full rounded-lg flex  items-center'>
                <CheckBoxV2
                  className={checkBoxStyles}
                  checked={isChecked}
                  key={menu.key}
                  onChange={(e) => {
                    handleChange(e, menu.key, menu.label)
                  }}
                  label={menu.label}
                />
                </div>
              )
            })}
          </div>
        </div>
      )}
    </div>
  )
}
